import { Env } from "core/utils";
export function pushToPrivacy(windowRef, item) {
    if (!Env.isClient)
        return;
    if (typeof windowRef._privacy === "undefined")
        return;
    if (typeof windowRef._privacy.push === "undefined")
        return;
    windowRef._privacy.push(item);
}
export function openPrivacyModal(windowRef, event) {
    event.preventDefault();
    if (!Env.isClient)
        return;
    if (typeof windowRef._privacy === "undefined")
        return;
    if (typeof windowRef._privacy.openModal === "undefined")
        return;
    windowRef._privacy.openModal();
}
